import React from "react";
const PartyIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.774 3.048s.903-2.71-2.71-2.71"
          stroke="#ED1C24"
          strokeWidth=".645"
        />
        <path
          d="M10.952 6.875s2.71-.904 2.71 2.71"
          stroke="#00A4FF"
          strokeWidth=".645"
        />
        <path
          d="M9.71 3.839s1.806.903 1.806-.904c0-.903.903-.903.903-.903s1.807 0 .904-1.806"
          stroke="#ED1C24"
          strokeWidth=".645"
        />
        <path
          d="M2.935 2.484a.678.678 0 1 1 .001-1.355.678.678 0 0 1 0 1.355M13.554 4.8l-.451.238-.06.507-.366-.356-.5.099.225-.457-.249-.445.505.072.346-.374.087.503z"
          fill="#BF0FCE"
        />
        <path
          fill="#00A4FF"
          d="m9.058.36-.301.442.194.498-.513-.149-.414.339-.017-.535-.45-.289.503-.181.136-.517.328.422z"
        />
        <path
          d="M11.95 10.04s.412.935 1.807 1.807"
          stroke="#ED1C24"
          strokeWidth=".645"
        />
        <path
          d="M9.422 2.705S9.556 1.26 10.96.909M10.417 13.02s.487-.946 1.616-.355"
          stroke="#00A4FF"
          strokeWidth=".645"
        />
        <g transform="rotate(45 .483 7.493)">
          <path fill="#FFD60B" d="M0 1.806h9.484L4.742 12.419z" />
          <path
            d="M8.806 1.806 4.742 12.42l-.773-2.017L7.26 1.806h1.546Z"
            fill="#FFB000"
          />
          <path
            d="m8.962 2.145-4.22 9.444-4.22-9.444h8.44Z"
            stroke="#975F00"
            strokeWidth=".677"
          />
          <ellipse
            stroke="#975F00"
            strokeWidth=".677"
            fill="#FFF"
            cx="4.742"
            cy="1.581"
            rx="4.403"
            ry="1.242"
          />
        </g>
      </g>
    </svg>
  )
);
PartyIcon.displayName = "PartyIcon";
export default PartyIcon;
